<script setup lang="ts">
import { Popover, PopoverButton, PopoverPanel, TransitionRoot } from '@headlessui/vue';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import HandIcon from '../../assets/icons/hand.svg';
import { useClassStore } from '../../stores';
import { computed, ref } from 'vue';
import { ClassStudentInfo } from '../../types/class';
import Modal from '../General/Modal.vue';
import SetPointStudent from './SetPointStudent.vue';

const classStore = useClassStore()
const modalSetPointStudentShow = ref<boolean>(false)
const selectedStudent = ref<ClassStudentInfo | null>(null)

const raiseHandStudents = computed<ClassStudentInfo[]>(() => {
    return classStore.raiseHandStudentIds.reduce<ClassStudentInfo[]>((students, studentId) => {
        const student = classStore.selectedClassDetails?.students?.find(student => student.id === studentId)
        if (student) {
            students.push(student)
        }
        return students
    }, [])
})

function handleRaiseHandStudentClick(student: ClassStudentInfo) {
    selectedStudent.value = student
    modalSetPointStudentShow.value = true
}

const { t } = useI18n()
</script>

<template>
    <Popover v-slot="{ open }" class="relative">
        <PopoverButton
            class="relative flex gap-2 w-full cursor-pointer disabled:cursor-not-allowed rounded-md bg-blue-600 border-blue-700 shadow-[0_4px_0] shadow-blue-700 disabled:opacity-50 text-white px-2.5 py-2 text-left focus:outline-none sm:text-sm"
            :disabled="raiseHandStudents.length <= 0">
            <HandIcon class="size-6" />
            <span class="truncate text-base hidden lg:block">
                {{ t(TEXT.raise_hand) }}
            </span>
            <span class=" min-w-5 px-1 h-5 flex justify-center items-center text-sm font-bold absolute top-0 right-0 -translate-y-[50%] translate-x-[50%]  bg-red-500 rounded-full" v-if="raiseHandStudents.length">
                {{ raiseHandStudents.length }}
            </span>
        </PopoverButton>
        <TransitionRoot appear :show="open" as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100" leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
            <PopoverPanel as="div" class="absolute mt-2 py-3 gap-3 w-full min-w-max rounded-md bg-white flex flex-col text-base shadow-neutral-200 shadow-[4px_4px_0] ring-1 ring-neutral-200 focus:outline-none sm:text-sm">
                <div class="flex flex-col gap-3 max-h-[50vh] overflow-y-auto scroll-smooth px-3">
                    <div class="text-blue-500 hover:text-blue-700 flex gap-2 items-center rounded-md cursor-pointer" @click="handleRaiseHandStudentClick(student)" v-for="student in raiseHandStudents">
                        <HandIcon class="size-5" />
                        <span class="block truncate">{{ student.full_name }}</span>
                    </div>
                </div>
            </PopoverPanel>
        </TransitionRoot>
        <Modal v-model="modalSetPointStudentShow" size="medium">
            <SetPointStudent v-if="selectedStudent !== null" :student="selectedStudent" :sections="classStore.selectedClassDetails?.sections || []" @update="modalSetPointStudentShow = false" />
        </Modal>
    </Popover>
</template>